module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0140.jpg?v=5f4c2d29";